import React from "react";
import { STANDARDS } from "../mock";

const Quote = () => {
  return (
    <>
      <section className="bg-0 py-8" data-testid="standards-section">
        <div className="max-w-6xl mx-auto px-6 flex flex-wrap lg:flex-nowrap items-center justify-center gap-x-6 lg:gap-x-10 gap-y-3">
          <p className="label !text-[0.6rem] whitespace-nowrap lg:mr-4">Marcos de referencia</p>
          {STANDARDS.map((s) => (
            <span key={s} className="text-base lg:text-lg font-light text-white/60 hover:text-white transition-colors whitespace-nowrap">{s}</span>
          ))}
        </div>
      </section>
    </>
  );
};

export default Quote;
